var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CourierForm',{attrs:{"courier":_vm.courier,"buttonLoading":_vm.buttonLoading},on:{"saveCourier":_vm.saveCourier}})
}
var staticRenderFns = []

export { render, staticRenderFns }